import { IAbcComponent } from '../abcComponent.model';

export interface IEditor extends IAbcComponent {
  tools: string;
  disabled?: boolean;
  activeStateEnabled?: boolean;
  focusStateEnabled?: boolean;
  hoverStateEnabled?: boolean;
  isValid?: boolean;
  name?: string;
  placeholder?: string;
  readOnly?: boolean;
  rtlEnabled?: boolean;
  tabIndex?: number;
  validationError?: string;
  validationErrors?: string;
  validationMessageMode?: EditorValidationMessageMode;
  validationStatus?: EditorValidationStatus;
  value?: string;
  visible?: boolean;
  saveIcon?: boolean;
  displayEdit?: boolean;
  showToolbar?: boolean;
  stylingMode?: StylingModeEditor;
  setEditorStyle(style?: EditorStyle);
}
export class EditorStyle {
  height: string | number;
  width: string | number;
}

export enum EditorValidationMessageMode {
  Always = 'always',
  Auto = 'auto',
}
export enum EditorValidationStatus {
  Valid = 'valid',
  Invalid = 'invalid',
  Pending = 'pending',
}

export enum StylingModeEditor {
  Outlined = 'outlined',
  Underlined = 'underlined',
  Filled = 'filled',
}
